import styled from '@emotion/styled';
export const GreenSpacerTag = styled('div')({});
